import React from "react";

import {
    CardActivities,
    CardAll,
    CardEmployee,
    CardFamily,
    CardHouse,
    CardLeisure,
    CardOther,
    CardSavings,
    CardVehicle,
} from "@/assets/images/categories/card";
import {
    ListActivities,
    ListAll,
    ListEmployee,
    ListFamily,
    ListHouse,
    ListLeisure,
    ListOther,
    ListSavings,
    ListVehicle,
} from "@/assets/images/categories/list";

export class InsuredGoodRootCategory {
    constructor(
        public readonly id: string,
        public readonly categoryIcon: React.ReactElement,
        public readonly cardIcon: React.ReactElement,
        public readonly order: number,
    ) {}

    public static readonly other1 = new InsuredGoodRootCategory(
        "-1",
        <ListOther className="categoryIcon" />,
        <CardOther />,
        7,
    );
    public static readonly other2 = new InsuredGoodRootCategory(
        "-2",
        <ListOther className="categoryIcon" />,
        <CardOther />,
        8,
    );
    public static readonly all = new InsuredGoodRootCategory(
        "0",
        <ListAll className="categoryIcon" />,
        <CardAll />,
        1000,
    );
    public static readonly people = new InsuredGoodRootCategory(
        "1",
        <ListFamily className="categoryIcon" />,
        <CardFamily />,
        2,
    );
    public static readonly goods = new InsuredGoodRootCategory(
        "2",
        <ListHouse className="categoryIcon" />,
        <CardHouse />,
        1,
    );
    public static readonly car = new InsuredGoodRootCategory(
        "3",
        <ListVehicle className="categoryIcon" />,
        <CardVehicle />,
        0,
    );
    public static readonly finances = new InsuredGoodRootCategory(
        "4",
        <ListSavings className="categoryIcon" />,
        <CardSavings />,
        4,
    );
    public static readonly leisure = new InsuredGoodRootCategory(
        "5",
        <ListLeisure className="categoryIcon" />,
        <CardLeisure />,
        3,
    );
    public static readonly employee = new InsuredGoodRootCategory(
        "11",
        <ListEmployee className="categoryIcon" />,
        <CardEmployee />,
        5,
    );
    public static readonly activity = new InsuredGoodRootCategory(
        "15",
        <ListActivities className="categoryIcon" />,
        <CardActivities />,
        6,
    );
    public static readonly unknown = new InsuredGoodRootCategory("1000", null, null, 1001);

    public static values = [
        InsuredGoodRootCategory.other1, // fixme find the real meaning
        InsuredGoodRootCategory.other2, // fixme find the real meaning
        InsuredGoodRootCategory.all,
        InsuredGoodRootCategory.people,
        InsuredGoodRootCategory.goods,
        InsuredGoodRootCategory.car,
        InsuredGoodRootCategory.finances,
        InsuredGoodRootCategory.leisure,
        InsuredGoodRootCategory.employee,
        InsuredGoodRootCategory.activity,
    ];

    public static getFromId(itemId: string): InsuredGoodRootCategory {
        for (const item of InsuredGoodRootCategory.values) {
            if (item.id === itemId) {
                return item;
            }
        }
        return InsuredGoodRootCategory.unknown;
    }
}
